import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'

import { HttpLinkModule } from 'apollo-angular-link-http'
import { ApolloModule } from 'apollo-angular'
import { Apollo } from 'apollo-angular'
import { HttpClientModule } from '@angular/common/http'

import { GraphqlProvider } from './graphql.provider'

import { BaseService } from './base.service'
import { ConfigService } from './config.service'
import { StatusService } from './status.service'
import { ApolloService } from './apollo.service'
import { NotificationsService, NotificationType, INotification } from './notifications.service'
import { UtilsService } from './utils.service'
import { MenuService } from './menu.service'
import { StyleService } from './style.service'
import { DownloadService } from './download.service'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ApolloModule,
    HttpLinkModule,
    HttpClientModule
  ],
  providers: [
    GraphqlProvider,
    ConfigService,
    StatusService,
    ApolloService,
    NotificationsService,
    UtilsService,
    MenuService,
    StyleService,
    DownloadService,
  ]
})
class ServicesModule { }

export {
  ServicesModule,
  BaseService,
  ConfigService,
  StatusService,
  ApolloService,
  NotificationsService, NotificationType, INotification,
  UtilsService,
  MenuService,
  StyleService,
  DownloadService,
}
